// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"822e01db","286":"8750b394","314":"c3976ce3","328":"db226c61","420":"6387bf9e","732":"0f9221af","741":"756ae922","771":"d4959246"}[chunkId] + ".chunk.css";
};